module.exports = __webpack_public_path__ + "static/financial_access6-9f9e2d522eeb4c7b4308415e259a8c3f.png";